import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flex: 1,
  },
  forms: {
    display: 'flex',
    flexBasis: 'auto',
    gap: theme.spacing(1),
  },
  button: {
    display: 'flex',
    flexBasis: 'auto',
    flex: 1,
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    outline: 'none',
    width: '100%',
  },
}))

export default useStyles
